<?php

\Core\View::$template = function () {

    $html = '   
        <div class="container">
            <div class="row"> 
                <div class="col-sm-6 offset-sm-3 col-12" >
                    <div>
                        <h4>New Job</h4>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-12">
                            <div class="form-group">
                                <label>Job Title</label>
                                <input type="text" name="tilte" class="form-control" id="job_tilte" value=""/>
                            </div>
                        </div>
                       
                       <div class="col-sm-12 col-12">
                            <div class="form-group">
                                <label>Role Type</label>
                                <select id="role_type" name="role_type" class="form-control">
                                     <option value="Software engineer">Software engineer</option>
                                     <option value="Designer">Designer</option>
                                     <option value="Data scientist">Data scientist</option>
                                     <option value="Product manager">Product manager</option>
                                     <option value="Marketer">Marketer</option>
                                     <option value="Recruiting">Recruiting</option>
                                </select>
                            </div>
                        </div>
                        
                        <div class="col-sm-12 col-12">
                                <div class="form-group">
                                    <label>Description</label>
                                    <textarea name="description" id="description" class="form-control" rows="10" cols="30"></textarea>
                                </div>
                        </div>
                        
                        <div class="col-sm-12 col-12">
                            <div class="form-group">
                                <label>Level</label>
                                <select id="level" name="level" class="form-control">
                                     <option value="Senior">Senior</option>
                                     <option value="Mid">Mid</option>
                                     <option value="Junior">Junior</option>
                                </select>
                            </div>
                        </div>
                        
                        <div class="col-sm-12 col-12">
                            <div class="form-group">
                                <label>Type</label>
                                <select id="type" name="type" class="form-control">
                                     <option value="Full Time">Full Time</option>
                                     <option value="Contractor">Contractor</option>
                                </select>
                            </div>
                        </div>
                        
                        <div class="col-sm-12 col-12">
                                <div class="form-group">
                                    <label>Location</label>
                                    <input type="text" name="location" class="form-control" id="location" value=""/>
                                </div>
                        </div>
                        
                        <div class="col-sm-12 col-12">
                                <div class="form-group">
                                    <label>Contact Person</label>
                                    <input type="text" name="contact_person" class="form-control" id="contact_person" value=""/>
                                </div>
                        </div>
                        
                        <div class="col-sm-12 col-12 text-center">
                            <span id="post_new_job" class="btn btn-success">Save</span>
                            <span id="go-jobs-list" class="btn btn-warning">Job List</span>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>';

    return $html;

};


// WEBPACK FOOTER //
// app/JobList/View/JobNewPost.php